import type { PropsWithChildren, ReactNode } from 'react';
import { StyleSheet, View } from 'react-native';
import {
  SafeAreaView,
  useSafeAreaInsets,
} from 'react-native-safe-area-context';

import { colors } from '@/src/theme/colors';
import { spacing } from '@/src/theme/spacing';

import {
  AuthenticatedBottomTabBar,
  getStableBottomInset,
} from './AuthenticatedBottomTabBar';
import { AuthenticatedHeader } from './AuthenticatedHeader';

export function AppChromeShell({
  backFallbackPath,
  bottomContent,
  children,
  fixedBottomTabs = false,
  forceBackFallback = false,
  hideBottomTabs = false,
}: PropsWithChildren<{
  backFallbackPath?: string;
  bottomContent?: ReactNode;
  fixedBottomTabs?: boolean;
  forceBackFallback?: boolean;
  hideBottomTabs?: boolean;
}>) {
  const insets = useSafeAreaInsets();
  const bottomInset = getStableBottomInset(insets.bottom);

  return (
    <SafeAreaView edges={['left', 'right']} style={styles.safeArea}>
      <AuthenticatedHeader
        backFallbackPath={backFallbackPath}
        forceBackFallback={forceBackFallback}
      />
      <View style={styles.content}>{children}</View>
      {bottomContent ? (
        <View
          style={[
            styles.bottomContent,
            { paddingBottom: bottomInset + spacing.sm },
          ]}
        >
          {bottomContent}
        </View>
      ) : hideBottomTabs ? null : (
        <AuthenticatedBottomTabBar fixed={fixedBottomTabs} />
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    backgroundColor: colors.background,
    flex: 1,
  },
  content: {
    backgroundColor: colors.background,
    flex: 1,
  },
  bottomContent: {
    backgroundColor: colors.surface,
    borderTopColor: colors.border,
    borderTopWidth: StyleSheet.hairlineWidth,
    paddingHorizontal: spacing.md,
    paddingTop: spacing.sm,
  },
});
